var _path, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "128mm",
    viewBox: "0 0 128 128",
    width: "128mm",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m58.152695 85.37341h15.014451v41.575455h-15.014451z",
    fill: "#4d4d4d",
    stroke: "#fff",
    strokeWidth: 5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#800080",
    height: 86.869324,
    ry: 12.768194,
    stroke: "#fff",
    strokeWidth: 10,
    width: 62.202721,
    x: 34.558567,
    y: 8.97826
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.8119873 0 0 1.8119873 43.673407 31.44754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4 16c0 .88.39 1.67 1 2.22v1.78c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22v-10c0-3.5-3.58-4-8-4s-8 .5-8 4z",
    fill: "#f9f9f9",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 16c0 .88.39 1.67 1 2.22v1.78c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22v-10c0-3.5-3.58-4-8-4s-8 .5-8 4zm3.5 1c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6h-12v-5h12z",
    fill: "#800080"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.6092868 12.157332h1.3636362v1.378299h-1.3636362z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.442131 12.157332h1.363637v1.378299h-1.363637z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.24565 12.157332h1.363637v1.378299h-1.363637z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.156642,
    cy: 14.61291,
    r: 0.740904
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.092126,
    cy: 14.61291,
    r: 0.740904
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.9bf4bdff10a56ff9f7337116315d8215.svg";
export { ForwardRef as ReactComponent };